/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import styles from "./dropDownList.module.scss";
import Button from "./../Button";
import { generateId } from "./../_util/common.js";
import DropDownMenu from "./DropDownMenu";

class DropDownList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      selectedOption: this.props.selectedOption || null,
      selectedDisplayValue:
        this.props.triggerType === "box" &&
          this.props.selectedOption !== null &&
          this.props.selectedOption !== undefined
          ? this.getDisplayTitleByValue(
            this.props.selectedOption,
            this.props.label
          )
          : this.props.label,
      index: 0,
      menuPosition: "",
      menuPositionX: "",
      isControlled: this.props.selectedOption !== undefined ? true : false,
      selectedMultipleValues: this.props.selectedOptions || [],
    };

    this.trigger = "";
    this.optionList = [];
    this.enabledArray = [];
    this.lastEnableElementIndex = "";
    this.firstEnableElementIndex = "";
    this.dynamicDropdownPosition = {
      "top": styles.menuTop,
      "bottom": styles.menuBottom,
      "left": styles.menuLeft,
      "right": styles.menuRight,
    }
  }

  getDisplayTitleByValue = (value, errortext) => {
    let response = errortext || "";
    const obj = this.props.options.find(
      (option) => value && option.value.toString() === value.toString()
    );
    if (obj && obj.display) {
      response = obj.display;
    }
    return response;
  };

  // Accessibility function
  onKeyPressed = (event) => {
    if (
      event.key === "ArrowDown" ||
      event.key === "Enter" ||
      event.key === "Escape" ||
      event.key === "ArrowUp" ||
      event.key === " "
    ) {
      if (this.props.stopPropagation) {
        event.stopPropagation();
      }
      if (this.props.preventDefault) {
        event.preventDefault();
      }
      this.onNavigation(event);
    } else if (event.key === "Tab" && this.state.dropdownOpen) {
      this.setState({ dropdownOpen: false }, () => {
        this.trigger.focus();
      });
    } else {
      this.searchOptions(event);
    }
  };

  // Accessibility function
  onNavigation = (event) => {
    if (
      (event.key === "Enter" || event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === " ") &&
      this.state.dropdownOpen === false
    ) {
      this.menuTrigger(event);
    } else if (event.key === "Enter" && this.state.dropdownOpen && event.target.getAttribute("aria-disabled") !== "true") {
      if (this.props.multipleSelect) {
        const index = this.props.options.findIndex(
          (x) => x.value.toString() === event.target.value
        );
        this.onCheckboxChange(
          event.target.ariaChecked === "true" || event.target.checked ? false : true,
          index
        );
      } else {
        this.setState(
          {
            selectedOption: document.activeElement.parentElement.dataset.value,
            dropdownOpen: false,
          },
          () => {
            this.props.onGetSelectedOption(this.state.selectedOption);
            this.setState({
              selectedDisplayValue: this.getDisplayTitleByValue(
                this.state.selectedOption,
                this.props.label
              ),
            });
            this.trigger.focus();
          }
        );
      }
    }

    if (event.key === "Escape" && this.trigger !== "") {
      this.setState({ dropdownOpen: false }, () => {
        this.trigger.focus();
      });
    }

    if (event.key === "ArrowDown" && this.state.dropdownOpen) {
      let optionIndex = this.state.index;
      if (this.state.index > this.lastEnableElementIndex) {
        optionIndex = this.firstEnableElementIndex;
      }
      let count = 0;

      if (this.state.index >= this.lastEnableElementIndex) {
        this.optionList[this.firstEnableElementIndex].focus();
        this.setState({ index: this.firstEnableElementIndex });
      } else {
        while (this.optionList.slice(optionIndex + 1)[count].disabled) {
          count++;
        }
        let incrementCount =
          this.state.index === this.optionList.length - 1
            ? 0
            : count > 0
              ? count + 1
              : 1;
        this.setState({ index: optionIndex + incrementCount }, () => {
          this.optionList[this.state.index].focus();
        });
      }
    }

    if (event.key === "ArrowUp" && this.state.dropdownOpen) {
      let optionIndex = this.state.index;
      if (this.state.index < 0) {
        optionIndex = this.lastEnableElementIndex;
      }
      let count = 0;

      if (this.state.index <= this.firstEnableElementIndex) {
        this.optionList[this.lastEnableElementIndex].focus();
        this.setState({ index: this.lastEnableElementIndex });
      } else {
        while (
          this.optionList.slice(0, optionIndex)[optionIndex - count - 1]
            .disabled
        ) {
          count++;
        }
        let incrementCount =
          this.state.index === 0 ? 0 : count > 0 ? count + 1 : 1;
        this.setState({ index: optionIndex - incrementCount }, () => {
          this.optionList[this.state.index].focus();
        });
      }
    }
  };

  findEnableElements = () => {
    for (let i = 0; i < this.optionList.length; i++) {
      if (this.optionList[i].disabled === false) {
        this.firstEnableElementIndex = i;
        break;
      } else {
        this.firstEnableElementIndex = null;
      }
    }
    for (let i = this.optionList.length - 1; i >= 0; i--) {
      if (this.optionList[i].disabled === false) {
        this.lastEnableElementIndex = i;
        break;
      } else {
        this.lastEnableElementIndex = null;
      }
    }
  };

  searchOptions = (event) => {
    let input = event.key.toLowerCase();
    for (let i = 0; i < this.optionList.length; i++) {
      if (
        this.optionList[i].innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) === 0
      ) {
        this.optionList[i].focus();
        break;
      } else {
        this.optionList[i].blur();
        this.trigger.focus();
      }
    }
  };

  onOptionSelect = (event) => {
    if (this.props.stopPropagation) {
      event.stopPropagation();
    }
    if (!this.props.multipleSelect) {
      this.setState(
        {
          selectedOption: event.currentTarget.dataset.value,
          dropdownOpen: false,
        },
        () => {
          this.props.onGetSelectedOption(this.state.selectedOption);
          this.trigger.focus();
          this.setState({
            selectedDisplayValue: this.getDisplayTitleByValue(
              this.state.selectedOption,
              this.props.label
            ),
          });
        }
      );
    }
  };

  menuPositionCalculate = () => {
    const dropdownPositionValue = this.dynamicDropdownPosition[this.props.dropdownPosition];
    let inputWrapper = document
      .getElementById(this.props.id)
      .getBoundingClientRect();
    let windowHeight = window.innerHeight;
    let menuHeight = document
      .querySelector(`#${this.props.id}`)
      .querySelector(`#ls-dropdown-menu-${this.props.id}`).clientHeight;
    let menuWidth = document
      .querySelector(`#${this.props.id}`)
      .querySelector(`#ls-dropdown-menu-${this.props.id}`).clientWidth;


    if (this.props.dropdownPosition !== undefined && this.dynamicDropdownPosition.hasOwnProperty(this.props.dropdownPosition?.toString())) {
      this.setState({ menuPosition: dropdownPositionValue });
    } else if (
      menuHeight > windowHeight - inputWrapper.bottom &&
      menuHeight < inputWrapper.top
    ) {
      this.setState({ menuPosition: styles.menuTop });
    } else {
      this.setState({ menuPosition: styles.menuBottom });
    }

    if (this.props.menuPositionX === undefined) {
      if (
        menuWidth < inputWrapper.right - this.props.addRightMargin &&
        (this.props.triggerType === "icon" || this.props.triggerType === "icon_card")
      ) {
        this.setState({ menuPositionX: styles.menuLeft });
      } else {
        this.setState({ menuPositionX: styles.menuRight });
      }
    } else {
      if (this.props.menuPositionX === "menuLeft") {
        this.setState({ menuPositionX: styles.menuLeft });
      } else if (this.props.menuPositionX === "menuRight") {
        this.setState({ menuPositionX: styles.menuRight });
      }
    }
  }

  menuTrigger = (e) => {
    if (this.props.stopPropagation) {
      e.stopPropagation();
    }

    this.setState(
      {
        dropdownOpen: !this.state.dropdownOpen,
      },
      () => {
        if (this.state.dropdownOpen) {
          this.getOptionList();
          this.menuPositionCalculate();
          this.findEnableElements();
          if (
            this.state.dropdownOpen &&
            this.firstEnableElementIndex !== null &&
            this.optionList.length !== 0
          ) {
            this.optionList[this.firstEnableElementIndex].focus();
            this.setState({ index: this.firstEnableElementIndex });
          }
        }
      }
    );
  };

  getOptionList = () => {
    this.optionList = Array.from(
      document.querySelectorAll(`[id^="ls-option-${this.props.id}"]`)
    );
    this.trigger = document
      .querySelector(`#${this.props.id}`)
      .querySelector(`#trigger-${this.props.id}`);
  };

  handleClickOutside = (evt) => {
    this.setState({ dropdownOpen: false });
  };

  renderCheckboxDropdown = () => {
    return (
      <button
        className={`${styles.dropdown_checkbox} ${this.props.id}---dropdown-handler`}
        onClick={(e) => this.menuTrigger(e)}
        id={`trigger-${this.props.id}`}
        aria-label={
          this.props.triggerType === "checkbox"
            ? `${this.props.label.toLowerCase() === `dropdown` ? `dropdown` : `${this.props.label} dropdown`}`
            : `dropdown menu, selected value ${this.state.selectedDisplayValue}`
        }
        aria-haspopup="listbox"
        aria-expanded={this.state.dropdownOpen ? "true" : "false"}
        role="combobox"
      >
        <Icon
          name={`dropup-${generateId()}`}
          fileName={
            this.state.selectedOption === "all"
              ? "checkbox-on-24"
              : this.state.selectedOption === "none" ||
                this.state.selectedOption === null
                ? "checkbox-off-24"
                : "checkbox-tristate-24"
          }
          className={
            this.state.selectedOption === "all"
              ? styles.dropdown_checkbox_icon
              : this.state.selectedOption === "none" ||
                this.state.selectedOption === null
                ? styles.dropdown_checkbox_icon_off
                : styles.dropdown_checkbox_icon
          }
          isHidden={true}
        />
        <Icon
          name={`drop-${generateId()}`}
          fileName={this.state.dropdownOpen ? "drop-up-18" : "drop-down-18"}
          className={styles.dropdown_checkbox_drop_icon}
          isHidden={true}
        />
      </button>
    );
  };

  renderButtonDropdown = () => {
    const { options, multipleSelect } = this.props;

    return (
      <button
        className={
          this.props.triggerType === "button"
            ? `${styles.dropdown_btn} ${styles[this.props.buttonType]} ${styles[this.props.buttonSize]
            } ${this.props.id}---dropdown-handler`
            : `${styles.dropdown_box} ${this.props.id}---dropdown-handler`
        }
        style={
          this.props.isDisabled
            ? {
              width: this.props.boxWidth,
              color: "#6A7070",
              pointerEvents: "none",
              backgroundColor: "#e9e9e9",
            }
            : { width: this.props.boxWidth }
        }
        onClick={(e) => this.menuTrigger(e)}
        id={`trigger-${this.props.id}`}
        aria-labelledby={`dropdown_label_${this.props.id} trigger-${this.props.id}-label`}
        aria-haspopup="listbox"
        aria-expanded={this.state.dropdownOpen ? "true" : "false"}
        disabled={this.props.isDisabled}
        role="combobox"
      >
        <label className={styles.drop_label} aria-hidden id={`trigger-${this.props.id}-label`}>
          {this.props.triggerType === "button" || this.props.multipleSelect
            ? `${this.props.label}`
            : `${this.state.selectedDisplayValue}`}
        </label>
        <Icon
          name={`drop-${generateId()}`}
          fileName={this.state.dropdownOpen ? "drop-up-24" : "drop-down-24"}
          className={
            this.props.triggerType === "button"
              ? styles.dropdown_btn_arrow_icon
              : styles.dropdown_box_arrow_icon
          }
          isHidden={true}
        />
      </button>
    );
  };

  renderLabelDropdown = () => {
    return (
      <div className={`${this.props.id}---dropdown-handler`}>
        <div
          className={styles.dropdown_label}
          onClick={(e) => this.menuTrigger(e)}
          tabIndex="0"
          id={`trigger-${this.props.id}`}
          role="button"
          aria-label={`${this.props.label.toLowerCase() === `dropdown` ? `dropdown` : `${this.props.label} dropdown`}`}
          aria-haspopup="listbox"
          aria-expanded={this.state.dropdownOpen ? "true" : "false"}
        >
          <label
            style={{ cursor: "pointer" }}
            className={
              this.state.dropdownOpen ? styles.dropdown_label_select : undefined
            }
          >
            {this.props.label}
          </label>
          <Icon
            name={`drop-${generateId()}`}
            fileName={this.state.dropdownOpen ? "drop-up-24" : "drop-down-24"}
            className={
              this.state.dropdownOpen && styles.dropdown_label_icon_label
            }
            isHidden={true}
          />
        </div>
      </div>
    );
  };

  renderIconDropdown = () => {
    const dropdownFileName = this.props.fileName?.split("-")?.[0];
    return (
      <div className={`${this.props.id}---dropdown-handler`}>
        <Button
          varient="icon"
          onClick={(e) => this.menuTrigger(e)}
          style={{
            minWidth: this.props.boxWidth,
            minHeight: this.props.boxWidth,
          }}
          id={`trigger-${this.props.id}`}
          aria-label={`${this.props.label.toLowerCase() === `dropdown` ? `dropdown` : `${this.props.label} dropdown`}`}
          aria-haspopup="listbox"
          active={this.state.dropdownOpen ? 1 : 0}
          role="combobox"
          aria-expanded={this.state.dropdownOpen ? "true" : "false"}
          disabled={this.props.isDisabled}
        >
          {this.props.triggerType === "icon" ||
            this.props.triggerType === "icon_card" ? (
            <Icon name={`${dropdownFileName}-${generateId()}`} id={`${dropdownFileName}`} fileName={this.props.fileName} />
          ) : (
            this.props.label
          )}
        </Button>
        <span className={styles.drop_icon}>
          {this.props.downIcon && this.props.triggerType === "avatar" && (
            <Icon
              name={`drop-down-${generateId()}`}
              fileName="drop-down-18"
              isHidden={true}
            />
          )}
        </span>
      </div>
    );
  };

  onCheckboxChange = (val, index) => {
    const existing = this.state.selectedMultipleValues.findIndex(
      (x) => x === index
    );
    let newSelectedMultipleValues = this.state.selectedMultipleValues.slice();

    if (val && existing === -1) {
      newSelectedMultipleValues.push(index);
    } else if (!val && existing > -1) {
      newSelectedMultipleValues.splice(existing, 1);
    }

    this.setState({ selectedMultipleValues: newSelectedMultipleValues }, () => {
      const { options } = this.props;
      const response = newSelectedMultipleValues.map((i) => {
        return options[i];
      });
      this.props.onGetSelectedOption(response);
    });
  };

  componentDidUpdate(prevProps) {
    if (
      (this.state.isControlled &&
        this.state.selectedOption !== this.props.selectedOption)
      || (prevProps.options && this.props.options && prevProps.options.length !== this.props.options.length)) {
      this.setState({
        selectedOption: this.props.selectedOption,
        selectedDisplayValue: this.getDisplayTitleByValue(
          this.props.selectedOption,
          this.props.label
        ),
      });
    };

    if (prevProps.selectedOptions !== this.props.selectedOptions) {
      this.setState({
        selectedMultipleValues: this.props.selectedOptions
      });
    }

    if (prevProps.resetValue !== this.props.resetValue && this.props.resetValue === this.props.label) {
      this.setState({ selectedDisplayValue: this.props.label, selectedOption: null })
    }
  }

  render() {
    return (
      <div>
        {this.props.dropdownDescription && (
          <label
            className={styles.dropdown_description}
            id={`dropdown_label_${this.props.id}`}
          >
            {this.props.dropdownDescription}
          </label>
        )}
        <div
          className={styles.dropdown}
          id={this.props.id}
          onKeyDown={this.onKeyPressed}
          role="option"
        >
          <div>
            {(this.props.triggerType === "button" ||
              this.props.triggerType === "box") &&
              this.renderButtonDropdown()}

            {this.props.triggerType === "label" && this.renderLabelDropdown()}

            {(this.props.triggerType === "icon" ||
              this.props.triggerType === "avatar" ||
              this.props.triggerType === "icon_card") &&
              this.renderIconDropdown()}

            {this.props.triggerType === "checkbox" &&
              this.renderCheckboxDropdown()}
          </div>

          {/* dropdowm menu starts here */}
          <DropDownMenu
            options={this.props.options}
            triggerType={this.props.triggerType}
            multipleSelect={this.props.multipleSelect}
            id={this.props.id}
            menuWidth={this.props.menuWidth}
            isCheckboxEnabled={this.props.isCheckboxEnabled}
            handleClickOutside={this.handleClickOutside}
            state={this.state}
            onOptionSelect={this.onOptionSelect}
            onCheckboxChange={this.onCheckboxChange}
            outsideClickIgnoreClass={`${this.props.id}---dropdown-handler`}
            addTopMargin={this.props.addTopMargin}
          ></DropDownMenu>
        </div>
      </div>
    );
  }
}

DropDownList.propTypes = {
  addRightMargin: PropTypes.number,
  addTopMargin: PropTypes.string,
  resetValue: PropTypes.string,
  boxWidth: PropTypes.string,
  buttonSize: PropTypes.string,
  buttonType: PropTypes.string,
  dropdownDescription: PropTypes.string,
  downIcon: PropTypes.bool,
  id: PropTypes.string,
  isCheckboxEnabled: PropTypes.bool,
  isDisabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  menuWidth: PropTypes.string,
  menuPosition: PropTypes.string,
  menuPositionX: PropTypes.string,
  ariaLabel: PropTypes.string,
  options: PropTypes.array.isRequired,
  onGetSelectedOption: PropTypes.func.isRequired,
  seperator: PropTypes.bool,
  triggerType: PropTypes.string.isRequired,
  selectedOption: PropTypes.string,
  preventDefault: PropTypes.bool,
  stopPropagation: PropTypes.bool,
  multipleSelect: PropTypes.bool,
  selectedOptions: PropTypes.array,
  fileName: PropTypes.string,
  dropdownPosition: PropTypes.string,
};

DropDownList.defaultProps = {
  id: generateId(),
  addRightMargin: 0,
  addTopMargin: "0",
  label: "",
  resetValue: "",
  boxWidth: null,
  dropdownDescription: "",
  menuWidth: null,
  onGetSelectedOption: () => {
    /**/
  },
  isCheckboxEnabled: true,
  preventDefault: true,
  stopPropagation: false,
  multipleSelect: false,
  fileName: "more-24"
};
export default DropDownList;
